import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/data/faqs";

export default function Faq() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <SEO
        title="FAQs | Checkout DM — Instagram DM Checkout Questions Answered"
        description="Everything merchants ask about Checkout DM — pricing, payments, Instagram setup, returns, security, and more, all in one place."
        path="/faq"
        structuredData={faqSchema}
      />
      <Navbar />

      <section className="px-6 pt-16 pb-10 md:px-12 md:pt-24">
        <div className="mx-auto max-w-3xl text-center md:text-left">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-hotpink">
            FAQ
          </p>
          <h1 className="mt-3 font-display text-4xl leading-[0.95] tracking-tighter md:text-6xl">
            Everything you were about to DM us.
          </h1>
          <p className="mt-5 text-lg text-ink/70">
            {faqs.length} answers on pricing, payments, Instagram setup, and
            more. Still stuck?{" "}
            <Link to="/contact" className="font-semibold text-hotpink hover:underline">
              Contact us
            </Link>{" "}
            directly.
          </p>
        </div>
      </section>

      <section className="px-6 pb-24 md:px-12">
        <div className="mx-auto max-w-3xl rounded-[2rem] border border-ink/10 bg-white p-8 md:p-12">
          <Accordion type="multiple" className="w-full" data-testid="faq-full-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-full-item-${i + 1}`}
                className="border-b border-ink/10 last:border-b-0"
              >
                <AccordionTrigger className="text-left font-display text-lg font-black tracking-tight hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-ink/70">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <Footer />
    </>
  );
}
